var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLitmus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_806_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6188e-05 127.94C2.6188e-05 140.427 1.79903 152.492 5.13303 163.901L75.753 140.77C73.7843 132.27 73.944 123.415 76.218 114.992L5.09503 92.109C1.70776 103.751 -0.00773072 115.815 2.6188e-05 127.94",
    fill: "#6A7A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5971 87.948L48.9461 27.277C30.1921 42.024 15.6641 61.898 7.46606 84.785L78.7551 107.722C82.0817 100.057 87.1662 93.2829 93.5971 87.948",
    fill: "#A09440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.211 75.836V0C98.583 0.745 74.848 9.027 55.136 22.7L99.861 83.472C107.23 78.972 115.592 76.3499 124.211 75.836",
    fill: "#AFA148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.044 148.12L7.51196 171.222C15.828 194.367 30.616 214.425 49.703 229.203L93.234 169.311C86.4907 163.617 81.2705 156.335 78.044 148.12Z",
    fill: "#4C5C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9341 233.725C75.4881 247.071 98.9271 255.144 124.211 255.88V181.728C115.432 181.203 106.923 178.492 99.4591 173.84L55.9341 233.725",
    fill: "#48555D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.148 22.212C180.609 8.85401 157.182 0.763005 131.909 0.00500488V75.931C140.259 76.6254 148.324 79.2985 155.436 83.729L200.148 22.212",
    fill: "#E3B23B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.909 181.633V255.875C157.38 255.111 180.977 246.899 200.608 233.353L156.363 173.234C149.035 178.019 140.631 180.905 131.909 181.633",
    fill: "#903024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.495 168.577L206.812 228.794C225.845 213.902 240.546 193.736 248.74 170.5L177.091 147.448C174.026 155.578 169.014 162.833 162.495 168.577",
    fill: "#D65841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 127.94C256 115.298 254.16 103.088 250.746 91.554L178.702 115.151C180.872 123.292 181.071 131.832 179.281 140.065L251.077 163.165C254.349 151.71 256.006 139.854 256 127.94",
    fill: "#E6703E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.188 107.874L248.342 84.24C240.01 61.303 225.31 41.422 206.375 26.739L161.657 88.265C167.955 93.587 172.929 100.3 176.188 107.874",
    fill: "#F4A83A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_806_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitmus);
export default __webpack_public_path__ + "static/media/litmus.0b22987018970eae5aeb0977e6547cc1.svg";
export { ForwardRef as ReactComponent };